import Utility from "../../../../../../plugins/ttzeg/src/references/utility";

export default class General {
    constructor() {

        const comparableContainers = document.querySelectorAll('.wp-block-create-block-references');
        if (comparableContainers) {
            comparableContainers.forEach((container) => {
                const utility = new Utility(container);
            });
        }

    }
}

